import styled, { css } from 'styled-components';

export type StyledFilterProps = {
  flexBasis?: string;
  flex?: number;
};

const Container = styled.div`
  padding: 2rem 0;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;

  margin-bottom: 1.2rem;
`;

const Filters = styled.div`
  display: flex;
  flex-direction: column;
`;

const FilterContainer = styled.div`
  display: flex;
  gap: 2rem;

  margin-bottom: 1.6rem;
`;

const Filter = styled.div<StyledFilterProps>`
  flex-basis: ${({ flexBasis }) => flexBasis || '100%'};
  ${({ flex }) =>
    flex
      ? css`
          flex: ${flex};
        `
      : null}
`;

const Buttons = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 2rem;
  flex: 1;
`;

export { Container, Header, Filters, FilterContainer, Filter, Buttons };
